import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './Button.css'
import classNames from 'classnames'

@CSSModules(styles, { allowMultiple: true })

export class Button extends Component {
  render () {
    const {
      small,
      medium,
      large,
      secondary,
      onClick,
      text,
      marginRight,
      marginLeft,
      autoFocus,
      loading
    } = this.props

    const buttonStyles = classNames('button', {
      small: small,
      medium: medium,
      large: large,
      secondary: secondary,
      'margin-right': marginRight,
      'margin-left': marginLeft,
      loading: loading
    })

    const disabled = this.props.disabled ? 'disabled' : ''

    return (
      <button 
        autoFocus={autoFocus}
        disabled={disabled}
        onClick={onClick} 
        styleName={buttonStyles}>
        <span>{text}</span>
      </button>
    )
  }
}

Button.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  loading: PropTypes.bool,
  marginLeft: PropTypes.bool,
  marginRight: PropTypes.bool,
  medium: PropTypes.bool,
  onClick: PropTypes.func,
  secondary: PropTypes.bool,
  size: PropTypes.string,
  small: PropTypes.bool,
  text: PropTypes.string.isRequired
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/Button.js